import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../../components/DashboardLayout';
import { CheckCircle, Loader2, XCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AddonSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [trialEnd, setTrialEnd] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (!sessionId) { setStatus('error'); return; }

    const poll = async () => {
      const token = localStorage.getItem('token');
      try {
        const res = await axios.get(
          `${API}/api/addon/lieferung/checkout-status/${sessionId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (res.data.status === 'completed') {
          if (res.data.trial_end) {
            const d = new Date(res.data.trial_end);
            setTrialEnd(d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }));
          }
          setStatus('success');
          window.dispatchEvent(new CustomEvent('modulesUpdated'));
        } else {
          setTimeout(poll, 2000);
        }
      } catch {
        setStatus('error');
      }
    };
    poll();
  }, [searchParams]);

  return (
    <DashboardLayout>
      <div className="flex items-center justify-center min-h-[60vh] p-8">
        <div className="text-center max-w-md">
          {status === 'loading' && (
            <>
              <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto mb-4" />
              <h2 className="text-xl font-bold mb-2">Aktivierung läuft…</h2>
              <p className="text-muted-foreground text-sm">Bitte einen Moment Geduld.</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle className="h-12 w-12 text-green-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold mb-2">Lieferschein-KI-Manager aktiviert!</h2>
              <p className="text-muted-foreground text-sm mb-2">
                Ihr Modul ist jetzt aktiv und sofort nutzbar.
              </p>
              {trialEnd && (
                <p className="text-sm font-medium text-blue-600 dark:text-blue-400 mb-6">
                  Kostenlos bis {trialEnd} · Danach 1,99&nbsp;€/Monat
                </p>
              )}
              <Button onClick={() => navigate('/admin')} className="w-full sm:w-auto">
                Zum Dashboard
              </Button>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
              <h2 className="text-xl font-bold mb-2">Etwas ist schiefgelaufen</h2>
              <p className="text-muted-foreground text-sm mb-6">
                Bitte kontaktieren Sie support@allflowx.de
              </p>
              <Button variant="outline" onClick={() => navigate('/admin')}>Zurück</Button>
            </>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
